import React, { useState,useEffect } from "react";
import { auth } from "../firebase/firebaseConfig"; // Adjust the path to your Firebase configuration
import { signOut, sendPasswordResetEmail } from "firebase/auth";
import { useLoading } from "./Loading";
import { useAuth } from "../contexts/authContext";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
    const {setLoading} = useLoading();
    const {currentUser} = useAuth();
    const navigate = useNavigate();

    useEffect(()=>{
        setTimeout(() => {
            setLoading(false);
        }, 10);
        if(currentUser)
          {
              navigate('/');
          }
    },[])
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage(""); // Clear previous messages
    setError(""); // Clear previous errors

    await signOut(auth);
      sendPasswordResetEmail(auth, email)
        .then(() => {
          console.log("Password reset email sent!");
          alert("If an account with that email exists, a password reset link has been sent.");
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error("Password reset error:", errorCode, errorMessage);
          alert("An error occurred. Please try again.");
        });
    };


  return (
    <div className="forgotPasswordContainer">
      <div className="forgotPasswordForm">
        <h1>Forgot Password</h1>
        <form onSubmit={handleResetPassword}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Send Reset Email</button>
        </form>
        {message && <p className="successMessage">{message}</p>}
        {error && <p className="errorMessage">{error}</p>}
        <p>
          Remember your password? <a href="/login">Login</a>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
